import { Send, Twitter, Activity } from "lucide-react";

export const Footer = ({ onJoin }) => {
  return (
    <footer
      data-testid="footer-section"
      className="relative bg-[#05060A] border-t border-[#14f19522] pt-16 pb-10"
    >
      <div className="mx-auto max-w-7xl px-5 lg:px-8">
        <div className="flex flex-col lg:flex-row justify-between gap-10">
          <div className="max-w-sm">
            <span className="font-display font-black text-2xl tracking-tight text-white">
              500<span className="text-[#14F195] text-glow-green">X</span>
            </span>
            <p className="mt-4 text-sm text-[#94A3B8] leading-relaxed">
              The most accurate meme coin insider group on Solana. Pre-public airdrops,
              custom sniper bots and live whale tracking.
            </p>
            <div
              data-testid="rpc-latency"
              className="mt-5 inline-flex items-center gap-2 rounded-full border border-[#14f19533] bg-[#14f1950f] px-3 py-1.5"
            >
              <Activity className="w-3.5 h-3.5 text-[#14F195] animate-pulse" />
              <span className="font-mono text-[10px] uppercase tracking-wider text-[#14F195]">
                Solana RPC · 42ms
              </span>
            </div>
          </div>

          <div className="flex flex-col gap-4">
            <button
              onClick={onJoin}
              className="inline-flex items-center justify-center rounded-full bg-[#14F195] px-6 py-3 text-sm font-bold text-[#05060A] hover:bg-[#3dffb0] transition-colors"
            >
              Join VIP · 2 SOL
            </button>
            <div className="flex items-center gap-3">
              <a
                href="#"
                className="inline-flex items-center justify-center w-10 h-10 rounded-full border border-[#ffffff14] text-[#94A3B8] hover:text-[#14F195] hover:border-[#14f19544] transition-colors"
                aria-label="Twitter"
              >
                <Twitter className="w-4 h-4" />
              </a>
              <a
                href="#"
                className="inline-flex items-center justify-center w-10 h-10 rounded-full border border-[#ffffff14] text-[#94A3B8] hover:text-[#14F195] hover:border-[#14f19544] transition-colors"
                aria-label="Telegram"
              >
                <Send className="w-4 h-4" />
              </a>
            </div>
          </div>
        </div>

        <div className="mt-12 pt-8 border-t border-[#ffffff0f]">
          <p data-testid="crypto-disclaimer" className="font-mono text-[11px] leading-relaxed text-[#4b5563] max-w-4xl">
            RISK DISCLAIMER: 500X is a private research & signals community. Nothing here is
            financial advice. Crypto and meme coins are extremely high risk — you can lose 100%
            of your capital. Past performance does not guarantee future results. Payments are
            non-refundable digital access fees. Participate only with funds you can afford to lose.
          </p>
          <p className="mt-4 font-mono text-[11px] text-[#4b5563]">
            © {new Date().getFullYear()} 500X Insider Group. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};
